import { type Variants } from 'framer-motion';

import { SORT_ICON_SIZE_LEFT, SORT_ICON_SIZE_RIGHT } from './styles';

export const MOTION_VARIANTS: Variants = {
    leftTapping: {
        width: SORT_ICON_SIZE_LEFT,
        borderRadius: '20px',
        x: 2,
    },
    left: {
        width: SORT_ICON_SIZE_LEFT,
        borderRadius: '20px',
        x: 2,
    },
    rightTapping: {
        width: SORT_ICON_SIZE_RIGHT,
        borderRadius: '20px',
        x: SORT_ICON_SIZE_LEFT,
    },
    right: {
        width: SORT_ICON_SIZE_RIGHT,
        borderRadius: '20px',
        x: SORT_ICON_SIZE_LEFT,
    },
};
